/**
 * The app's own top-level routes (plan F1.4: Meeting / History / Users /
 * Groups).
 *
 * Kept in one place because the lobby reads the first path segment as a
 * session id, for invite links like `/<sessionId>?meetingName=...`. Without
 * this list, opening `/history` would start a preview of a session called
 * "history". Now that the lobby stays mounted beside the lists on wide
 * screens, that would happen on every visit.
 */
export const LIST_ROUTES = ['history', 'users', 'groups'] as const;
export type ListRoute = (typeof LIST_ROUTES)[number];

export const APP_ROUTES: readonly string[] = ['meeting', ...LIST_ROUTES];

/** The first path segment, if it names one of the list tabs. */
export function listRouteOf(pathname: string): ListRoute | null {
  const first = pathname.split('/').filter(Boolean)[0] ?? '';
  return (LIST_ROUTES as readonly string[]).includes(first)
    ? (first as ListRoute)
    : null;
}
